import React from "react";
import { NavLink } from "react-router-dom";
import { User, Package, Archive, Gift } from "lucide-react";
import StoreLayout from "./StoreLayout";
import { useAuth } from "../context/AuthContext";

export default function AccountLayout({ children }) {
  const { user } = useAuth();

  const navs = [
    { to: "/account/orders", label: "My Orders", icon: Package, end: false },
    { to: "/account/past-orders", label: "Past Orders", icon: Archive, end: false },
    { to: "/account/affiliate", label: "Sell & Earn", icon: Gift, end: false },
    { to: "/account/profile", label: "My Profile", icon: User, end: false },
  ];

  return (
    <StoreLayout>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-10">
        <p className="label-mono text-[#71717A]">// ACCOUNT</p>
        <h1 className="font-display font-black text-4xl md:text-5xl uppercase tracking-tight mt-2 mb-8">
          Hey, <span className="text-[#CFF048]">{user?.name?.split(" ")[0] || "Cult Member"}</span>
        </h1>

        <div className="grid md:grid-cols-[260px_1fr] gap-8">
          {/* Sidebar — user info + nav. Logout lives in the top navbar. */}
          <aside className="border border-[#27272A] bg-[#0A0A0A] h-fit" data-testid="account-sidebar">
            <div className="p-5 border-b border-[#27272A]">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#CFF048] text-black font-display font-black flex items-center justify-center text-lg">
                  {(user?.name || "?")[0].toUpperCase()}
                </div>
                <div className="min-w-0">
                  <p className="font-display font-bold truncate">{user?.name}</p>
                  <p className="label-mono text-[#71717A] truncate text-[10px]">{user?.email}</p>
                </div>
              </div>
            </div>
            <nav className="py-2">
              {navs.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.end}
                  className={({ isActive }) => `admin-nav-item ${isActive ? "active" : ""}`}
                  data-testid={`account-nav-${n.label.toLowerCase().replace(/ /g, "-")}`}
                >
                  <n.icon size={16} />
                  <span>{n.label}</span>
                </NavLink>
              ))}
            </nav>
          </aside>

          <div>{children}</div>
        </div>
      </div>
    </StoreLayout>
  );
}
